import request from '@/utils/request'

export function getAccountRevenueApi(query) {
  return request({
    url: '/cashier-service/v1/accounting-revenue',
    method: 'get',
    params: query
  })
}

export function updateAccountRevenueApi(payload) {
  return request({
    url: '/cashier-service/v1/accounting-revenue',
    method: 'post',
    data: payload
  })
}

export function getCashierRevenueApi(query) {
  return request({
    url: '/cashier-service/v1/accounting-revenue/cashier',
    method: 'get',
    params: query
  })
}

export function updateAccountRevenueByCashier(payload) {
  return request({
    url: '/cashier-service/v1/accounting-revenue/update-status',
    method: 'post',
    data: payload
  })
}
